import { Utils } from "@/plugins/utils"
import moment from "moment"
import qs from "qs"

export function buildCv8SearchParams(state, search, limit, page) {
	return {
		search,
		limit,
		page,
		sinceEmit: state.sinceEmit || undefined,
		untilEmit: state.untilEmit || undefined,
		sinceVencim: state.sinceVencim || undefined,
		untilVencim: state.untilVencim || undefined,
		fn6Open: state.fn6Open.length > 0 ? state.fn6Open : [0, 1],
		cv5ToReceive: state.cv5ToReceive.length > 0 ? state.cv5ToReceive : [0, 1],
		showPrevision: state.showPrevision,
		showWriteoff: state.showWriteoff,
		cv5cliente: state.cv5cliente || undefined,
		cv5emissor: state.cv5emissor || undefined,
		cv8tipo: state.cv8tipo || undefined,
		fn5conta: state.fn5conta || undefined,
		cv8tipotit: state.cv8tipotit || undefined,
		cv8doc: state.cv8doc || undefined,
		fn5doc: state.fn5doc || undefined,
	}
}

const paramsSerializer = params => qs.stringify(params, { arrayFormat: "repeat", skipNulls: true })

export default {
	namespaced: true,
	state: {
		cv2nome: "",
		cv5clinome: "",
		cv5emisnom: "",
		cv5emissor: "",
		cv5cliente: "",
		cv5entsai: "",
		cv8doc: "",
		cv8tipo: "",
		cv8tipotit: "",
		cv8valor: "",
		cv8vencim: moment().format("YYYY-MM-DD"),
		details: false,
		cv5emissao: "",
		fn5doc: "",
		fn5conta: "",
		fn1nome: "",
		cv8comjuros: "",
		juros: "",
		addedPaymentCondition: 0,
		multa: "",
		fn6: {},
		fn5: {},
		lstFn1: [],
		lstFn3: [],
		lstFn5: [],
		lstFn6: [],
		cv8: {},
		lstCv8: [],
		lstCv8confirmed: [],
		tempLstCv8confirmed: [],
		calculationCv8Lst: [],
		cv5situa: "",
		cv5emitido: "",
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		sinceVencim: moment().format("YYYY-MM-DD 00:00"),
		untilVencim: moment().format("YYYY-MM-DD 23:59"),
		sinceEmit: "",
		untilEmit: "",
		hasNext: false,
		lastUpdatedRegister: null,
		pending: false,
		fn6Open: [1],
		cv5ToReceive: [0, 1],
		showPrevision: true,
		showWriteoff: false,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getCv8(state) {
			let cv8 = { ...state.cv8 }
			return cv8
		},
		getFn3(state) {
			let fn3 = { ...state.fn3 }
			return fn3
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, cv8) {
			state.cv8 = cv8
			if (cv8) state.update = true
		},
		setFn3(state, fn3) {
			state.fn3 = fn3
		},
		setLstFn3(state, lstFn3) {
			state.lstFn3 = lstFn3
		},
		setLstFn1(state, lstFn1) {
			state.lstFn1 = lstFn1
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.lstCv8confirmed = []
			state.cv8 = null
		},
		setParamsDataTable(state, payload) {
			let status
			state.lstCv8 = payload.items.map(s => {
				if (s.totalFn6 >= s.cv8valor) {
					status = Math.round(((s.totalFn6 + s.fn7valor) * 100) / s.cv8valor)
				} else {
					status =
						s.fn6valor != null && s.fn6valor !== "" ? Math.round(((s.fn6valor + s.fn7valor) * 100) / s.cv8valor) : 0
				}
				return { ...s, status, showDetails: false, cv8comjuros: 0, juros: 0 }
			})
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		resetCv8(state) {
			state.cv2nome = ""
			state.cv5clinome = ""
			state.cv5emisnom = ""
			state.cv5emissor = ""
			state.cv5cliente = ""
			state.cv5entsai = ""
			state.cv8doc = ""
			state.cv8tipo = ""
			state.cv8tipotit = ""
			state.cv8valor = ""
			state.cv8vencim = moment().format("YYYY-MM-DD")
			state.details = false
			state.cv5emissao = ""
			state.fn5doc = ""
			state.fn5conta = ""
			state.fn1nome = ""
			state.cv8comjuros = ""
			state.juros = ""
			state.addedPaymentCondition = 0
			state.multa = ""
			state.fn6 = {}
			state.fn5 = {}
			state.lstFn3 = []
			state.lstFn5 = []
			state.lstFn6 = []
			state.cv8 = {}
			state.lstCv8 = []
			state.lstCv8confirmed = []
			state.cv5situa = ""
			state.cv5emitido = ""
			state.insert = false
			state.update = false
			state.loading = false
			state.itemsPerPage = 20
			state.search = ""
			state.hasNext = false
			state.lastUpdatedRegister = null
			state.pending = false
		},
		toggleShowDetails(state, { cv8doc, cv8parcela, cv8tipo, cv8emissor, cv2nome }) {
			const item = state.lstCv8.find(
				cv8 =>
					cv8.cv8doc === cv8doc &&
					cv8.cv8parcela === cv8parcela &&
					cv8.cv8tipo === cv8tipo &&
					cv8.cv8emissor === cv8emissor &&
					cv8.cv2nome === cv2nome,
			)
			if (item) {
				item.showDetails = !item.showDetails
			}
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setCv8(state, cv8) {
			state.cv8 = cv8
		},
		setCv8Status(state, cv8status) {
			state.cv8status = cv8status
		},
		setLstCv8(state, lstCv8) {
			state.lstCv8 = lstCv8
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setCalculationCv8Lst(state, calculationCv8Lst) {
			state.calculationCv8Lst = calculationCv8Lst
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch }, cv8) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Financial/LiquidationTitle/FindCv8/${cv8}`)
				.then(response => {
					let cv8 = Utils.ValidateAxiosResponse(response.data)
					commit("set", cv8)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async search({ commit, getters, dispatch, state }, { limit = 10, page = 1 }) {
			state.tempLstCv8confirmed = state.lstCv8confirmed
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Buscando títulos", indeterminate: true },
				{ root: true },
			)
			commit("setLoading", true)
			commit("initForm")

			const params = buildCv8SearchParams(state, getters.getSearch, limit, page)

			let payload = await this._vm.$axios
				.get("/Financial/LiquidationTitle/SearchCv8Titles", { params, paramsSerializer })
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstCv8", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async calculateFooterValues({ commit, getters, dispatch, state }, { limit = 99999, page = 1 }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Calculando totais", indeterminate: true },
				{ root: true },
			)
			commit("setLoading", true)
			commit("initForm")

			const params = buildCv8SearchParams(state, getters.getSearch, limit, page)

			let payload = await this._vm.$axios
				.get("/Financial/LiquidationTitle/CalculateValuesCv8", { params, paramsSerializer })
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setCalculationCv8Lst", payload.items)
					return true
				})
				.catch(error => {
					commit("setCalculationCv8Lst", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async UpdateCv8Tipotit({ commit, dispatch }, cv8) {
			let payload = await this._vm.$axios
				.put("/Financial/LiquidationTitle/UpdateCv8Tipotit", cv8)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			return payload
		},
		async findListFn3({ commit, dispatch }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get("/Financial/LiquidationTitle/FindListFn3")
				.then(response => {
					let lstFn3 = Utils.ValidateAxiosResponse(response.data)
					commit("setLstFn3", lstFn3)
				})
				.catch(error => {
					commit("setLstFn3", [])
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
		},
		async findfn3ByFn1({ state, dispatch, commit }, agente) {
			if (!agente) {
				agente = state.cv8.cv8agente
			}
			return await this._vm.$axios
				.get(`/Financial/LiquidationTitle/Findfn3ByFn1?fn1agente=${agente}`)
				.then(response => {
					let lstFn3 = Utils.ValidateAxiosResponse(response.data)
					commit("setLstFn3", lstFn3)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
		},
		async findAllFn1({ dispatch, commit }) {
			return await this._vm.$axios
				.get(`/Financial/LiquidationTitle/FindAllFn1`)
				.then(response => {
					let lstFn1 = Utils.ValidateAxiosResponse(response.data)
					commit("setLstFn1", lstFn1)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return []
				})
		},
	},
}
